import React, { useEffect } from 'react';
import { GeoJSON, Popup, Pane } from 'react-leaflet';
import L from 'leaflet';


const GeojsonLayer = ({ map, geojsonData }) => {
    const key = Date.now();

    const colorMapping = {
        GES: ["green", 1000],
        subGES: ["red", 500],
        brak: ["#6b778a", 100],
    };

    useEffect(() => {
        if (map && geojsonData && geojsonData.length > 0) {
            let combinedBounds = null;

            geojsonData.forEach(item => {
                if (item.geom_geojson && item.geom_geojson.features) {
                    item.geom_geojson.features.forEach(feature => {
                        if (feature.geometry) {
                            const geoJsonLayer = L.geoJSON(feature.geometry);
                            const featureBounds = geoJsonLayer.getBounds();

                            if (combinedBounds) {
                                combinedBounds.extend(featureBounds);
                            } else {
                                combinedBounds = featureBounds;
                            }
                        }
                    });
                }
            });

            map.current.fitBounds(combinedBounds, { animate: true });
        }
    }, [geojsonData, map]);

    return (
        <>
            {geojsonData.filter((item) => item.ocena === "brak").map((item, index) => (
                <Pane style={{ zIndex: colorMapping[item.ocena][1] }}>
                    <GeoJSON
                        key={`${key}${index}`}
                        data={item.geom_geojson}
                        style={{
                            color: colorMapping[item.ocena][0],
                            opacity: 1,
                            fillOpacity: 0.2
                        }}
                    >
                        {item.wiarygodnosc !== "brak" && item.wiarygodnosc !== "Brak" &&
                            <Popup className={"custom-leaflet-popup"}>
                                <p style={{ fontFamily: "Open Sans, sans-serif", fontSize: "13px" }}>{"wiarygodność: "}
                                    <span style={{ color: "#2c5a82" }}>{item.wiarygodnosc}</span></p>
                            </Popup>
                        }
                    </GeoJSON>
                </Pane>
            ))}

            {geojsonData.filter((item) => item.ocena === "subGES").map((item, index) => (
                <Pane style={{ zIndex: colorMapping[item.ocena][1] }}>
                    <GeoJSON
                        key={`${key}${index}`}
                        data={item.geom_geojson}
                        style={{
                            color: colorMapping[item.ocena][0],
                            opacity: 1,
                            fillOpacity: 0.2
                        }}
                    >
                        {item.wiarygodnosc !== "brak" && item.wiarygodnosc !== "Brak" &&
                            <Popup className={"custom-leaflet-popup"}>
                                <p style={{ fontFamily: "Open Sans, sans-serif", fontSize: "13px" }}>{"wiarygodność: "}
                                    <span style={{ color: "#2c5a82" }}>{item.wiarygodnosc}</span></p>
                            </Popup>
                        }
                    </GeoJSON>
                </Pane>
            ))}

            {geojsonData.filter((item) => item.ocena === "GES").map((item, index) => (
                <Pane style={{ zIndex: colorMapping[item.ocena][1] }}>
                    <GeoJSON
                        key={`${key}${index}`}
                        data={item.geom_geojson}
                        style={{
                            color: colorMapping[item.ocena][0],
                            opacity: 1,
                            fillOpacity: 0.2
                        }}
                    >
                        {item.wiarygodnosc !== "brak" && item.wiarygodnosc !== "Brak" &&
                            <Popup className={"custom-leaflet-popup"}>
                                <p style={{ fontFamily: "Open Sans, sans-serif", fontSize: "13px" }}>{"wiarygodność: "}
                                    <span style={{ color: "#2c5a82" }}>{item.wiarygodnosc}</span></p>
                            </Popup>
                        }
                    </GeoJSON>
                </Pane>
            ))}
        </>
    );
};

export default GeojsonLayer;